import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import XcircleIcon from 'icons/Xcircle.icon';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import { getUserFullNameOrEmail } from 'utils';

import './DocumentsViewAsBanner.styles.scss';
import './DocumentsViewAsBanner.styles.responsive.scss';

const DocumentsViewAsBanner = () => {
  const { updateBuySidePreviewMember, buySidePreviewMember } = useContext(
    DataRoomDocumentsContext,
  );

  const name = getUserFullNameOrEmail(buySidePreviewMember);

  const { t } = useTranslation();

  return (
    <div
      className={classNames('documents-view-as-banner', {
        visible: !!buySidePreviewMember,
      })}
    >
      <p>
        {t('viewingAccessWarning', {
          name,
        })}
      </p>

      <Button
        variant="outline"
        onClick={() => updateBuySidePreviewMember(null)}
      >
        <XcircleIcon />
        {t('stop')}
      </Button>
    </div>
  );
};

export default DocumentsViewAsBanner;
